<template>
    <q-page padding>
        <q-tabs v-model="tab" class="shadow-1 q-mt-md bg-white" color="white" text-color="primary" align="justify">
            <q-tab slot="title" name="user-info" icon="fal fa-info" :label="$q.platform.is.mobile ? '' : $t('user_info')" />
            <q-tab slot="title" name="basic-data" icon="fal fa-clipboard-list-check" :label="$q.platform.is.mobile ? '' : $t('basic_data')" />
            <q-tab slot="title" name="certificates" icon="fal fa-award" :label="$q.platform.is.mobile ? '' : $t('certificates')" />

            <q-tab-pane name="user-info" keep-alive>
                <user-info />
            </q-tab-pane>

            <q-tab-pane name="basic-data" keep-alive>
                <basic-data />
            </q-tab-pane>

            <q-tab-pane name="certificates" keep-alive>
                <certificates />
            </q-tab-pane>
        </q-tabs>
    </q-page>
</template>

<script>
import BasicData from 'components/profile/BasicData'
import Certificates from 'components/profile/Certificates'
import UserInfo from 'components/profile/UserInfo'


export default {
    i18nOptions: { namespaces: [ 'custom', 'common', 'profile', 'users' ] },

    components: {
        'basic-data': BasicData,
        'certificates': Certificates,
        'user-info': UserInfo
    },

    data() {
        return {
            tab:'user-info'
        }
    },
    created() {
        if (this.$route.name === 'profile_basic_data') this.tab = 'basic-data'
    }

}
</script>

<style >

</style>
